import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import TheNav from "@/layouts/Pc/TheNav.vue";
import TheFooter from "@/layouts/Pc/TheFooter.vue";
import MbTheNav from "@/layouts/Mobile/MbTheNav.vue";
import MbTheFooter from "@/layouts/Mobile/MbTheFooter.vue";
import { onMounted, ref, computed } from "vue";
import { useRouter } from "vue-router";
import useLocale from "@/hooks/useLocale"; // 国际化hook
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const router = useRouter();
const isPrerender = Boolean(window.__PRERENDER_INJECTED?.prerender);
const isshow = ref(isPrerender ? !router.currentRoute.value.path.startsWith('/mb_') : true);

// 计算属性，基于当前语言生成key
const langKey = computed(() => {
  return store.getters.lang + Date.now(); // 添加时间戳确保每次切换都重新渲染
});

onMounted(() => {
  // Render the requested route, without the visitor device redirect.
  if (isPrerender) return;
  setTimeout(() => {
    if (_isMobile()) {
      isshow.value = false;
      router.replace(
        router.currentRoute.value.fullPath.indexOf("mb") !== -1
          ? router.currentRoute.value.fullPath
          : "/mb_home"
      );
    } else {
      isshow.value = true;
      router.replace(
        router.currentRoute.value.fullPath.indexOf("mb") === -1
          ? router.currentRoute.value.fullPath
          : "/home"
      );
    }
  });
});
// 判断是否是手机端，如果是，返回true
function _isMobile() {
  return !!navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
}

const {
  changeLocale, // 修改国际化
} = useLocale();
// 切换语言
let lang;
if (window.location.search.indexOf("lang") !== -1) {
  lang = window.location.search.slice(-2);
  window.localStorage.setItem("locale", lang ? lang : "zh");
  changeLocale(lang);
} else {
  changeLocale(
    localStorage.getItem("lang") ? localStorage.getItem("lang")! : "zh"
  );
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isshow.value)
      ? (_openBlock(), _createBlock(TheNav, { key: 0 }))
      : _createCommentVNode("", true),
    (!isshow.value)
      ? (_openBlock(), _createBlock(MbTheNav, { key: 1 }))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_component_router_view, { key: langKey.value })),
    (!isshow.value)
      ? (_openBlock(), _createBlock(MbTheFooter, { key: 2 }))
      : _createCommentVNode("", true),
    (isshow.value)
      ? (_openBlock(), _createBlock(TheFooter, { key: 3 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})